import Typography from '@material-ui/core/Typography';
import VocabularyManagerIcon from '../../core/icons/VocabularyManager';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../../core/withGShoc';
import DataManagerIcon from '../../core/icons/DataManager';

class ProjectLink extends React.Component {

    render() {

        const { data, defaultLang, id, locked, color, margin, displayNotAvailable } = this.props;
        const projectLang = data.defaultLang;

        return (
            <Typography
                data-test="project-link"
                variant="caption"
                style={{
                    overflow: 'hidden',
                    display: 'inline-block',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    ...(margin) && { marginTop: 4 },
                    ...(color) && { color }
                }}>
                {data.type === "DataProject" ?
                    <DataManagerIcon data-test="dm-icon" fontSize="small" fill={color} style={{ verticalAlign: 'bottom', marginRight: 4 }} />
                    :
                    <VocabularyManagerIcon data-test="vm-icon" fontSize="small" fill={color} style={{ verticalAlign: 'bottom', marginRight: 4 }} />
                }
                {data.title && data.title[defaultLang] ?
                    data.title[defaultLang]
                    :
                    data.title && data.title[projectLang] ?
                        data.title[projectLang]
                        :
                        displayNotAvailable ?
                            <span data-test="display-not-available">Project not available (you may need permissions).</span>
                            :
                            id}
                {locked && <span data-test="locked"> (This project is currently locked)</span>}
            </Typography>
        );
    }
}

ProjectLink.defaultProps = {
    displayNotAvailable: false,
    color: '#808080'
};

ProjectLink.propTypes = {
    color: PropTypes.string,
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired,
    locked: PropTypes.bool,
    margin: PropTypes.bool,
    displayNotAvailable: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
};

export default withGS(ProjectLink, ["ALL"], ["id", "type", "title", "hasEntitlement", "defaultLang"], { predicates: ["http://purl.org/dc/terms/title"] });